<section class="payments-page">
    <div class="payments-hero">
        <div>
            <span>Pagos seguros</span>
            <h2>Administra tus tarjetas</h2>
            <p>Agrega o elimina métodos de pago para completar tus citas sin capturar datos cada vez.</p>
        </div>
        <button type="button" class="payments-hero__button" (click)="openDialog()">
            <mat-icon>add_card</mat-icon>
            Agregar tarjeta
        </button>
    </div>

    <div class="saved-cards" *ngIf="savedCards.length > 0">
        <article class="saved-card" *ngFor="let c of savedCards">
            <div class="saved-card__brand">
                <img *ngIf="c.brand == 'amex'" src="./assets/img/amex.png" alt="amex">
                <img *ngIf="c.brand == 'mastercard'" src="./assets/img/mastercard.jpg" alt="mastercard">
                <img *ngIf="c.brand == 'visa'" src="./assets/img/visa.svg" alt="visa">
                <mat-icon *ngIf="c.brand !== 'amex' && c.brand !== 'mastercard' && c.brand !== 'visa'">credit_card</mat-icon>
            </div>
            <div class="saved-card__info">
                <span>{{ c.brand || 'Tarjeta' }}</span>
                <strong>{{ c.card_number }}</strong>
                <small>Expira {{ c.expiration_month }} / {{ c.expiration_year }}</small>
            </div>
            <button type="button" class="saved-card__delete" (click)="deleteCard(c.id)">
                Borrar
            </button>
        </article>
    </div>

    <div class="payments-empty" *ngIf="savedCards.length === 0">
        <div class="payments-empty__icon">
            <mat-icon>credit_card_off</mat-icon>
        </div>
        <h3>No tienes tarjetas guardadas</h3>
        <p>Agrega una tarjeta para dejar listo tu método de pago antes de agendar.</p>
        <button type="button" (click)="openDialog()">
            <mat-icon>add</mat-icon>
            Agregar tarjeta
        </button>
    </div>

    <footer class="payment-partners">
        <div>
            <span>Se acepta</span>
            <div class="payment-partners__cards">
                <img src="../../../assets/img/mastercard.jpg" alt="Mastercard">
                <img src="../../../assets/img/amex.png" alt="American Express">
                <img src="../../../assets/img/visa.svg" alt="Visa">
            </div>
        </div>
        <img class="payment-partners__openpay" src="../../../assets/img/LogotipoOpenpay-01.jpg" alt="OpenPay logo">
    </footer>
</section>

<div class="loading" *ngIf="isLoading">
    <mat-spinner></mat-spinner>
</div>
